import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as api from '../../api';
import * as logger from '../../logger';
import * as rootReducer from '../../reducers/root';
import * as store from '../../reducers/store';

import { applyTheme } from '../../utils';

/** Fetch and apply theme */
export const useTheme = ({
  domain,
  registrationCode,
  provisionalAuthCode,
  authCode,
  preventFallback,
}: {
  domain?: string;
  registrationCode?: string;
  provisionalAuthCode?: string;
  authCode?: string;
  preventFallback?: boolean;
} = {}): {
  isThemeLoading: boolean;
  theme: Partial<api.PracticeTheme.ThemeResponse>;
} => {
  const theme = useSelector((state: store.All) => state.theme);
  const dispatch = useDispatch();
  const [isThemeLoading, setIsThemeLoading] = useState(!theme);

  useEffect(() => {
    if (
      preventFallback &&
      !domain &&
      !registrationCode &&
      !provisionalAuthCode &&
      !authCode
    ) {
      return;
    }

    if (theme) return;
    const loadTheme = async () => {
      setIsThemeLoading(true);
      try {
        const theme = await api.client.Previsit.getThemeForLogin({
          domain: domain || window.location.hostname,
          registrationCode,
          provisionalAuthCode,
          authCode,
        });
        dispatch(rootReducer.setTheme(theme));
        applyTheme(theme);
      } catch (err) {
        logger.error(err, `[hooks.useTheme] Failed to load theme`);
      } finally {
        setIsThemeLoading(false);
      }
    };
    loadTheme();
  }, [
    preventFallback,
    domain,
    theme,
    registrationCode,
    provisionalAuthCode,
    authCode,
    dispatch,
  ]);

  return {
    isThemeLoading,
    theme: theme || {},
  };
};
